import React, {ReactElement, useMemo} from "react";
import {useLocation, useParams} from "react-router-dom";

import {ReportingActionRow} from "../../../atoms/admin-reporting/atoms/reporting-action-row";
import {Header} from "../../../atoms/reporting-block/Header";
import {ChecklistItem} from "../../../services/ReportingService";
import {QuicksightDashboard} from "../../../services/QuicksightService";
import {useReportingMenuDefinition} from "../reporting-menu/useReportingMenuDefinition";
import {useReportContext} from "../ReportContext";
import {resolveReportingBreadcrumbLabels} from "../reportingBreadcrumb.helpers";

type Props = Readonly<{
  checklistItems?: ReadonlyArray<ChecklistItem>;
  dashboardItems?: ReadonlyArray<QuicksightDashboard>;
  dateSelector: ReactElement;
}>;

export const ReportingPageActionRow = ({
  checklistItems = [],
  dashboardItems = [],
  dateSelector,
}: Props) => {
  const location = useLocation();
  const {sectionId, chartGroup} = useParams<{
    sectionId?: string;
    chartGroup?: string;
  }>();
  const {exportControls, selectedWorkflowLabel} = useReportContext();

  const menu = useReportingMenuDefinition(checklistItems, dashboardItems);

  const breadcrumb = useMemo(
    () =>
      resolveReportingBreadcrumbLabels(
        location.pathname,
        menu,
        selectedWorkflowLabel,
        {sectionId, chartGroup},
        checklistItems,
      ),
    [
      location.pathname,
      menu,
      selectedWorkflowLabel,
      sectionId,
      chartGroup,
      checklistItems,
    ],
  );

  const isAnalyticsDashboardRoute = location.pathname.includes(
    "/analytics/dashboards",
  );

  const exportControl =
    exportControls?.dataPath && exportControls.onExport ? (
      <Header
        inline
        dataPath={exportControls.dataPath}
        onExport={exportControls.onExport}
      />
    ) : null;

  return (
    <ReportingActionRow
      breadcrumb={breadcrumb}
      dateSelector={isAnalyticsDashboardRoute ? <></> : dateSelector}
      exportControl={exportControl}
    />
  );
};
